import React, { Component }  from 'react';

class Social extends Component {
    render() {
        return(
            <main id="social-page">
                <hr className="featurette-divider" />
                <div className="row featurette">
                    <div className="container marketing col-lg-12">
                        <div className="inner-marketing-row-wrapper row">
                            <div className="col-lg-12">
                                <div className="row gb-blue-box">
                                    <h3>Anticlimactic!</h3>
                                    <p>Yup. This doesn't exist yet. I have plans for this spot, it'll happen. =)</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        );
    }
}

export default Social;